<template>
  <CardFrame :bgColor="'blue'" hasDropShadow>
    <CardContainer :size="'small'">
      <div class="flex gap-8">
        <CardDate class="shrink-0" :date="data.eventTime.startTime"></CardDate>
        <CardBodyContainer>
          <CardTitle :headingTag="'h3'">{{ data.title }}</CardTitle>
          <CardEventBody
            :eventLocation="data.location"
            :eventTime="data.eventTime"
            :eventRegisterLink="data.registerLink"></CardEventBody>
        </CardBodyContainer>
      </div>
    </CardContainer>
  </CardFrame>
</template>

<script>
import Button from "../../Atoms/Button.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardDate from "../../Atoms/Cards/CardDate.vue";
import CardEventBody from "../../Atoms/Cards/CardEventBody.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import CardTitle from "../../Atoms/Cards/CardTitle.vue";

export default {
  components: {
    Button,
    CardContainer,
    CardEventBody,
    CardFrame,
    CardDate,
    CardTitle,
    CardBodyContainer,
    CardBody,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
